/**
 * A célula "Hash com o protocolo" (E91.F2, GUS-51 RF04/CA04).
 *
 * Uma célula só, usada pela tabela da pré-análise e pelo painel da mesa, para
 * que as duas telas respondam a pergunta do banco com as mesmas palavras e os
 * mesmos tons. Um tom por estado — e processamento NUNCA em tom de
 * sucesso: "está sendo verificado" não é "conferiu".
 */
import { Badge, type BadgeProps } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';
import type { HashComOProtocolo, RotulosDoResumo } from '@/lib/exame_eletronico_hash';

const tp = ptBR.exameEletronico.tabelaDePecas;

const TOM: Record<HashComOProtocolo, NonNullable<BadgeProps['variant']>> = {
  confere: 'success',
  divergente: 'danger',
  sem_referencia: 'warning',
  nao_conferivel: 'warning',
  nao_verificado: 'neutral',
  em_processamento: 'info',
};

/** Os rótulos do resumo, no formato que a lib pura consome. */
export const ROTULOS_DO_RESUMO: RotulosDoResumo = {
  documentos: { um: tp.resumo.documentosUm, varios: tp.resumo.documentos },
  confere: { um: tp.resumo.confereUm, varios: tp.resumo.confere },
  divergente: { um: tp.resumo.divergenteUm, varios: tp.resumo.divergente },
  sem_referencia: { um: tp.resumo.sem_referenciaUm, varios: tp.resumo.sem_referencia },
  nao_conferivel: { um: tp.resumo.nao_conferivelUm, varios: tp.resumo.nao_conferivel },
  nao_verificado: { um: tp.resumo.nao_verificadoUm, varios: tp.resumo.nao_verificado },
  em_processamento: { um: tp.resumo.em_processamentoUm, varios: tp.resumo.em_processamento },
};

export function HashComOProtocoloBadge({
  estado,
  titulo,
  testId,
}: {
  estado: HashComOProtocolo;
  /** O nome do documento, para o rótulo acessível dizer de quem é o estado. */
  titulo: string;
  testId: string;
}): JSX.Element {
  const rotulo = tp.hash[estado];
  return (
    <Badge
      variant={TOM[estado]}
      data-testid={testId}
      data-estado={estado}
      aria-label={tp.hashAria.replace('{peca}', titulo).replace('{estado}', rotulo)}
    >
      {rotulo}
    </Badge>
  );
}
